//InfoModal layer config for GEO09E03_CS_STA
define(function(require) {
    require("billboard.js/dist/billboard.css");
    var bb = require("billboard.js").bb;

    var infoTableConfig = {
        LAYER_ID: "GEO09E03_CS_STA",
        PANEL: {
            HEADER: {
                DATACOLUMNS: {"t_GEO09E03_CS_STA": ["CD_CS_STA", "NOM_OFFCL_CS_STA"]},
                CONTENT_FN: _createPanelHeader
            },
            SECTIONS: [
                {
                    DATACOLUMNS: {"t_GEO09E03_CS_STA": ["CD_CS_STA", "NOM_OFFCL_CS_STA"]},
                    CONTENT_FN: _createFeatureInfoTable
                }, {
                    DATACOLUMNS: {"t_GEO09E03_CS_STA": [
                        "DT_REALISATION",
                        "OBSE_AN0_M4", "PREVA_ANP1_M4", "PREVB_ANP2_M4","PREVC_ANP3_M4", "PREVD_ANP4_M4", "PREVE_ANP5_M4", "PREVF_ANP6_M4", "PREVG_ANP7_M4", "PREVH_ANP8_M4", "PREVI_ANP9_M4", "PREVJ_ANP10_M4",
                        "OBSE_AN0_M5", "PREVA_ANP1_M5", "PREVB_ANP2_M5","PREVC_ANP3_M5", "PREVD_ANP4_M5", "PREVE_ANP5_M5", "PREVF_ANP6_M5", "PREVG_ANP7_M5", "PREVH_ANP8_M5", "PREVI_ANP9_M5", "PREVJ_ANP10_M5",
                        "OBSE_AN0_M_TOT", "PREVA_ANP1_M_TOT", "PREVB_ANP2_M_TOT", "PREVC_ANP3_M_TOT", "PREVD_ANP4_M_TOT", "PREVE_ANP5_M_TOT", "PREVF_ANP6_M_TOT", "PREVG_ANP7_M_TOT", "PREVH_ANP8_M_TOT", "PREVI_ANP9_M_TOT", "PREVJ_ANP10_M_TOT",
                        "OBSE_AN0_P_TOT", "PREVA_ANP1_P_TOT", "PREVB_ANP2_P_TOT", "PREVC_ANP3_P_TOT", "PREVD_ANP4_P_TOT", "PREVE_ANP5_P_TOT", "PREVF_ANP6_P_TOT", "PREVG_ANP7_P_TOT", "PREVH_ANP8_P_TOT", "PREVI_ANP9_P_TOT", "PREVJ_ANP10_P_TOT",
                        "OBSE_AN0_P_TOT_M_TOT", "PREVA_ANP1_P_TOT_M_TOT", "PREVB_ANP2_P_TOT_M_TOT", "PREVC_ANP3_P_TOT_M_TOT", "PREVD_ANP4_P_TOT_M_TOT", "PREVE_ANP5_P_TOT_M_TOT", "PREVF_ANP6_P_TOT_M_TOT", "PREVG_ANP7_P_TOT_M_TOT", "PREVH_ANP8_P_TOT_M_TOT", "PREVI_ANP9_P_TOT_M_TOT", "PREVJ_ANP10_P_TOT_M_TOT",
                        "OBSE_AN0_S_TOT", "PREVA_ANP1_S_TOT", "PREVB_ANP2_S_TOT", "PREVC_ANP3_S_TOT", "PREVD_ANP4_S_TOT", "PREVE_ANP5_S_TOT", "PREVF_ANP6_S_TOT", "PREVG_ANP7_S_TOT", "PREVH_ANP8_S_TOT", "PREVI_ANP9_S_TOT", "PREVJ_ANP10_S_TOT",
                        "OBSE_AN0_TOTAL", "PREVA_ANP1_TOTAL", "PREVB_ANP2_TOTAL", "PREVC_ANP3_TOTAL", "PREVD_ANP4_TOTAL", "PREVE_ANP5_TOTAL", "PREVF_ANP6_TOTAL", "PREVG_ANP7_TOTAL", "PREVH_ANP8_TOTAL", "PREVI_ANP9_TOTAL", "PREVJ_ANP10_TOTAL"
                    ]},
                    CONTENT_FN: _createTable
                }, {
                    DATACOLUMNS: null,
                    CONTENT_FN: _createPrintMap
                }
            ]
        },
        PRINT_OPTIONS : {
            "landscape" : true
        }
    };

    function _createPanelHeader(feature, layer, featureData) {
        return '<h2 class="accordion-header">' +
                  '<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#InfoModal-panel-' + feature.id + '" aria-expanded="true" aria-controls="InfoModal-panel-' + feature.id + '">' +
                        featureData["CD_CS_STA"].VALUE + " - " + featureData["NOM_OFFCL_CS_STA"].VALUE +
                        '</button>' +
                    '</h2>';
    };

    function _createFeatureInfoTable(feature, layer, featureData) {
        return '<div class="InfoModal-printable" print-prepend="' + escape('<h4><strong><u>' + featureData["CD_CS_STA"].VALUE + " - " + featureData["NOM_OFFCL_CS_STA"].VALUE + '</u></strong></h4>') + '">' +
                    '<div class="InfoModal-panel-section" style="margin-top:0;">' +
                        '<h5><strong>Informations générales</strong></h5>' +
                        '<div class="InfoModal-featureInfo container-fluid">' +
                            _.map(featureData, function(data) {
                                return '<div class="row">' +
                                            '<div class="col-3">' + data.NAME + '&nbsp;:</div>' +
                                            '<div class="col-9">' + (data.VALUE != null ? data.VALUE.toLocaleString("fr-CA") : "<small>-</small>") + '</div>' +
                                        '</div>';
                            }).join("") +
                        '</div>' +
                    '</div>' +
                '</div>';
    };

    function _createPrintMap(feature, layer, featureData) {
        return '<div class="InfoModal-printable" print-map="true" style="display:none;"></div>';
    };

    function _createTable(feature, layer, featureData) {
        var actualYear = window.C.MAP_TOOLS.INFO_MODAL.EFFECTIFS_ACTUAL_YEAR;
        var $panelSection = $('<div class="InfoModal-printable">' +
                                '<div class="InfoModal-panel-section">' +
                                    '<h5><strong>Prévision de l\'effectif du centre de services scolaire ou de la commission scolaire selon l\'ordre d\'enseignement</strong></h5>' +
                                    '<table class="InfoModal-table table table-bordered">' +
                                        '<thead>' +
                                            '<tr style="border-width:0;">' +
                                                '<th colspan="2" style="border:none;"></th>' +
                                                '<th class="active" style="border-top: 1px solid #ddd;">Observations</th>' +
                                                '<th colspan="10" class="active" style="border-top: 1px solid #ddd;">Prévisions</th>' +
                                            '</tr>' +
                                            '<tr style="border-width:0;">' +
                                                '<th colspan="2" style="border:none;"></th>' +
                                                _.map(_.range(0, 11), function(yearDelta) {
                                                    return '<th class="active">' + (actualYear + yearDelta) + '-' + (actualYear + yearDelta +1) + '</th>';
                                                }).join("") +
                                            '</tr>' +
                                        '</thead>' +
                                        '<tbody>' +
                                            _createTableRow("Maternelle 4 ans", ["OBSE_AN0_M4", "PREVA_ANP1_M4", "PREVB_ANP2_M4","PREVC_ANP3_M4", "PREVD_ANP4_M4", "PREVE_ANP5_M4", "PREVF_ANP6_M4", "PREVG_ANP7_M4", "PREVH_ANP8_M4", "PREVI_ANP9_M4", "PREVJ_ANP10_M4"], featureData) +
                                            _createTableRow("Maternelle 5 ans", ["OBSE_AN0_M5", "PREVA_ANP1_M5", "PREVB_ANP2_M5","PREVC_ANP3_M5", "PREVD_ANP4_M5", "PREVE_ANP5_M5", "PREVF_ANP6_M5", "PREVG_ANP7_M5", "PREVH_ANP8_M5", "PREVI_ANP9_M5", "PREVJ_ANP10_M5"], featureData) +
                                            _createTableRow("Préscolaire", ["OBSE_AN0_M_TOT", "PREVA_ANP1_M_TOT", "PREVB_ANP2_M_TOT", "PREVC_ANP3_M_TOT", "PREVD_ANP4_M_TOT", "PREVE_ANP5_M_TOT", "PREVF_ANP6_M_TOT", "PREVG_ANP7_M_TOT", "PREVH_ANP8_M_TOT", "PREVI_ANP9_M_TOT", "PREVJ_ANP10_M_TOT"], featureData) +
                                            _createTableRow("Primaire", ["OBSE_AN0_P_TOT", "PREVA_ANP1_P_TOT", "PREVB_ANP2_P_TOT", "PREVC_ANP3_P_TOT", "PREVD_ANP4_P_TOT", "PREVE_ANP5_P_TOT", "PREVF_ANP6_P_TOT", "PREVG_ANP7_P_TOT", "PREVH_ANP8_P_TOT", "PREVI_ANP9_P_TOT", "PREVJ_ANP10_P_TOT"], featureData) +
                                            _createTableRow("Présecondaire", ["OBSE_AN0_P_TOT_M_TOT", "PREVA_ANP1_P_TOT_M_TOT", "PREVB_ANP2_P_TOT_M_TOT", "PREVC_ANP3_P_TOT_M_TOT", "PREVD_ANP4_P_TOT_M_TOT", "PREVE_ANP5_P_TOT_M_TOT", "PREVF_ANP6_P_TOT_M_TOT", "PREVG_ANP7_P_TOT_M_TOT", "PREVH_ANP8_P_TOT_M_TOT", "PREVI_ANP9_P_TOT_M_TOT", "PREVJ_ANP10_P_TOT_M_TOT"], featureData) +
                                            _createTableRow("Secondaire", ["OBSE_AN0_S_TOT", "PREVA_ANP1_S_TOT", "PREVB_ANP2_S_TOT", "PREVC_ANP3_S_TOT", "PREVD_ANP4_S_TOT", "PREVE_ANP5_S_TOT", "PREVF_ANP6_S_TOT", "PREVG_ANP7_S_TOT", "PREVH_ANP8_S_TOT", "PREVI_ANP9_S_TOT", "PREVJ_ANP10_S_TOT"], featureData) +
                                            _createTableRow("Total FGJ", ["OBSE_AN0_TOTAL", "PREVA_ANP1_TOTAL", "PREVB_ANP2_TOTAL", "PREVC_ANP3_TOTAL", "PREVD_ANP4_TOTAL", "PREVE_ANP5_TOTAL", "PREVF_ANP6_TOTAL", "PREVG_ANP7_TOTAL", "PREVH_ANP8_TOTAL", "PREVI_ANP9_TOTAL", "PREVJ_ANP10_TOTAL"], featureData) +
                                        '</tbody>' +
                                    '</table>' +
                                    '<div class="InfoModal-table-source"><small>Sources: DIS, ' + featureData["DT_REALISATION"].VALUE + '</small></div>' +
                                    '<div><small>Note: Ces données, limitées au secteur des jeunes, incluent les élèves en EHDAA, en francisation et en classe d\'accueil. Elles excluent les élèves à temps partiel ou en formation professionnelle. Les élèves en Animation Passe-Partout sont exclus de la maternelle 4 ans.</div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="InfoModal-printable" print-SVG="true">' +
                                '<div class="InfoModal-panel-section">' +
                                    '<div class="InfoModal-graph"></div>' +
                                '</div>' +
                            '</div>');
        new Promise((resolve, reject) => {
          resolve();
        }).then(function(){
        var graph = _createGraph($panelSection, featureData, actualYear);
        $panelSection.find(".InfoModal-row").mouseenter(function() {
            this.style.backgroundColor = graph.data.colors()[this.getAttribute("graph-data-id")];
            graph.focus(this.getAttribute("graph-data-id"));
        });
        $panelSection.find(".InfoModal-row").mouseleave(function() {
            this.style.backgroundColor = "unset";
            graph.revert();
            });
        });
        return $panelSection;
    };

    function _createTableRow(header, dataColumnIds, featureData) {
        return '<tr class="InfoModal-row" graph-data-id="' + header + '">' +
                    '<th colspan="2" class="active"><span class="InfoModal-cellHeader float-end">' + header + '</span></th>' +
                    _.map(dataColumnIds, function(dataColumnId, idx) {
                        return '<td>' + (typeof dataColumnId != "undefined" ? featureData[dataColumnId].VALUE.toLocaleString("fr-CA") : "") + '</td>';
                    }).join("") +
                '</tr>';
    };

    function _createGraph($panelSection, featureData, actualYear) {
        var categories = _.map(_.range(0, 11), function(yearDelta) { return (actualYear + yearDelta) + '-' + (actualYear + yearDelta +1); });
        var graph = bb.generate({
            "bindto": $panelSection.find(".InfoModal-graph")[0],
            "padding": {
                "left": 60,
                "right": 60
            },
            "size": {
                "height": 250,
                "width": 904
            },
            "data": {
                "x": "x",
                "columns": [
                    _.concat(["x"], categories),
                    _.concat(["Maternelle 4 ans"], _.map(["OBSE_AN0_M4", "PREVA_ANP1_M4", "PREVB_ANP2_M4","PREVC_ANP3_M4", "PREVD_ANP4_M4", "PREVE_ANP5_M4"], function(datacolumnId) { return Number(_.replace(featureData[datacolumnId].VALUE, ' ', '')); })),
                    _.concat(["Maternelle 5 ans"], _.map(["OBSE_AN0_M5", "PREVA_ANP1_M5", "PREVB_ANP2_M5","PREVC_ANP3_M5", "PREVD_ANP4_M5", "PREVE_ANP5_M5"], function(datacolumnId) { return Number(_.replace(featureData[datacolumnId].VALUE, ' ', '')); })),
                    _.concat(["Préscolaire"], _.map(["OBSE_AN0_M_TOT", "PREVA_ANP1_M_TOT", "PREVB_ANP2_M_TOT", "PREVC_ANP3_M_TOT", "PREVD_ANP4_M_TOT", "PREVE_ANP5_M_TOT"], function(datacolumnId) { return Number(_.replace(featureData[datacolumnId].VALUE, ' ', '')); })),
                    _.concat(["Primaire"], _.map(["OBSE_AN0_P_TOT", "PREVA_ANP1_P_TOT", "PREVB_ANP2_P_TOT", "PREVC_ANP3_P_TOT", "PREVD_ANP4_P_TOT", "PREVE_ANP5_P_TOT"], function(datacolumnId) { return Number(_.replace(featureData[datacolumnId].VALUE, ' ', '')); })),
                    _.concat(["Présecondaire"], _.map(["OBSE_AN0_P_TOT_M_TOT", "PREVA_ANP1_P_TOT_M_TOT", "PREVB_ANP2_P_TOT_M_TOT", "PREVC_ANP3_P_TOT_M_TOT", "PREVD_ANP4_P_TOT_M_TOT", "PREVE_ANP5_P_TOT_M_TOT"], function(datacolumnId) { return Number(_.replace(featureData[datacolumnId].VALUE, ' ', '')); })),
                    _.concat(["Secondaire"], _.map(["OBSE_AN0_S_TOT", "PREVA_ANP1_S_TOT", "PREVB_ANP2_S_TOT", "PREVC_ANP3_S_TOT", "PREVD_ANP4_S_TOT", "PREVE_ANP5_S_TOT", "PREVF_ANP6_S_TOT", "PREVG_ANP7_S_TOT", "PREVH_ANP8_S_TOT", "PREVI_ANP9_S_TOT", "PREVJ_ANP10_S_TOT"], function(datacolumnId) { return Number(_.replace(featureData[datacolumnId].VALUE, ' ', '')); })),
                    _.concat(["Total FGJ"], _.map(["OBSE_AN0_TOTAL", "PREVA_ANP1_TOTAL", "PREVB_ANP2_TOTAL", "PREVC_ANP3_TOTAL", "PREVD_ANP4_TOTAL", "PREVE_ANP5_TOTAL", "PREVF_ANP6_TOTAL", "PREVG_ANP7_TOTAL", "PREVH_ANP8_TOTAL", "PREVI_ANP9_TOTAL", "PREVJ_ANP10_TOTAL"], function(datacolumnId) { return Number(_.replace(featureData[datacolumnId].VALUE, ' ', '')); }))
                ],
                "type": "line"
            },
            "axis": {
                "x": {
                    "tick" : {
                        "centered" : true,
                        "culling" : false
                    },
                    "label": "Cohortes",
                    "type": "category"
                },
                "y": {
                    "min": 0
                }
            },
            "tooltip" : {
                "format" : {
                    "title" : function(xValue) { return "Cohorte de " + categories[xValue];}
                }
            },
            "legend": {
                "item": {
                    "onover": function(id) {
                        $panelSection.find('.InfoModal-row[graph-data-id="' + id +'"]')[0].style.backgroundColor = graph.data.colors()[id];
                        graph.focus(id);
                    },
                    "onout": function(id) {
                        $panelSection.find('.InfoModal-row[graph-data-id="' + id +'"]')[0].style.backgroundColor = "unset";
                        graph.revert();
                    }
                }
            }
        });
        return graph;
    };

    return infoTableConfig;
});
